import { render } from "./TabsPage.vue?vue&type=template&id=2ba2f0d4&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Developer\\Project\\auscultatio\\auscultatio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__